import axios from "axios"

export const getAllListPlans = {
  data() {
    return {
      getAllListPlansArray: [],
      overlay: false
    }
  },
  methods: {
    async getAllListPlansMethod() {
      try {
        const apiUrl = process.env.VUE_APP_AWS_LIST_PLANS_REST_API_END_POINT

        const result = await axios.post(apiUrl, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
        if (result.data.status === 'SUCCESS') {
          this.getAllListPlansArray = result.data.data
        }

        console.log('list Plans', this.getAllListPlansArray)
      } catch (error) {
        console.log('error in getAllListPlansMethod', error)

      } finally {
        this.overlay = false;
      }
    }
  },
}